<template>
  <div class="item-container">
    <!-- 图片 -->
    <a-carousel arrows :dots="false">
      <div
        class="img-container p-img-container"
        v-for="imgSrc in getPreviewImgs()"
        :key="imgSrc"
      >
        <img
          @load="calculateImg"
          v-if="imgSrc"
          @click="onImgClick"
          alt="pic"
          :src="imgSrc"
        />
        <div v-else class="no-img">{{ $t('common.no_img') }}</div>
      </div>
    </a-carousel>

    <!-- 标题 -->
    <div class="item-info j-content">
      <div
        class="modelNum j-might-overflow"
        v-html="!file.title ? '\u00a0' : file.title"
      ></div>
    </div>
    <!-- 操作 -->
    <div class="item-action">
      <a
        :style="a"
        v-if="file.filePath && file.filePath.length > 0"
        class="j-outline-btn1 j-height-auto ant-btn"
        target="_blank"
        :href="sysDefaultFileUrl + file.filePath"
        >{{ $t('download.download_btn') }}
      </a>
    </div>

    <!-- 预览 -->
    <PreviewImageModal
      @after-close="handleAfterClose"
      v-if="showPreviewModal"
      :images="getPreviewImgs()"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { sysDefaultFileUrl } from '@/utils/constants';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import { downloadFile } from '@/api/request';
// import ProductSpecModal from './ProductSpecModal.vue';

export default defineComponent({
  name: 'FileItem',
  components: {
    PreviewImageModal
    // ProductSpecModal
  },
  data() {
    return {
      a: {
        paddingTop: '10.5px',
        lineHeight: 1.5715
      },
      sysDefaultFileUrl,
      showPreviewModal: false,
      showAddToCartModal: false
    };
  },
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.p-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    getPreviewImgs() {
      const images: string[] = (this.file.snapshot || '')
        .split(',')
        .filter(s => s);

      return images.length > 0
        ? images.map(i => `${sysDefaultFileUrl}${i}`)
        : [''];
    },
    onImgClick() {
      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;
    },
    handleDownloadClick() {
      if (this.file.filePath) {
        const fileName = this.file.filePath.substring(
          this.file.filePath.indexOf('/') + 1,
          this.file.filePath.length
        );
        downloadFile(`/sys/common/static/${this.file.filePath}`, fileName, '');
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.item-container {
  border-radius: 1px;
  border: 1px solid $secondary-color2;

  &:hover {
    border: 1px solid $primary-color;
    transition: border 0.5s;
  }

  .img-container {
    cursor: pointer;
    display: block !important;

    img {
      display: inline-block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .no-img {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .item-info {
    background-color: $secondary-color1;
    padding: 14.5px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .modelNum {
      font-weight: bold;
      font-size: 13px;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 20px;
      display: flex;
      justify-content: center;
      word-break: break-all;
    }

    .vehicle-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: $primary-secondary-forecolor;
      text-align: right;
    }
  }

  .item-action {
    padding: 20px;
    display: flex;
    align-items: center;

    &::v-deep(.ant-btn) {
      flex: 1;
      &:first-child {
        margin-right: 20px;
      }
    }
  }
}

.ant-carousel ::v-deep(.slick-slide) {
  overflow: hidden;
}

.ant-carousel ::v-deep(.custom-slick-arrow:before) {
  display: none;
}

.ant-carousel ::v-deep(.slick-arrow.custom-slick-arrow) {
  width: 30px;
  height: 40px;
  color: #fff;
  font-size: 25px;
  background-color: $primary-color;
  display: flex !important;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: $primary-hover-color;
  }
}
</style>
